const INITIAL_STATE = {
  note: "",
};

const Checkout = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_CHECKOUT_NOTE":
      return { ...state, note: action.note };
    case "CLEAR_CHECKOUT_NOTE":
      return { ...state, note: "" };
    default:
      return state;
  }
};
export default Checkout;
